module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('step-title', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 0,
      "step": 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container pt-5 pb-5",
    class: {
      'bg-white': _vm.isEmpty
    }
  }, [(_vm.isEmpty) ? _c('empty-page', {
    attrs: {
      "title": "沒有考試作業",
      "description": "目前沒有任何已建立的指派考試作業。"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 offset-sm-2"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item d-flex justify-content-between mb-3 p-0 rounded",
      on: {
        "mouseover": function($event) {
          _vm.pointer = item.id
        },
        "mouseout": function($event) {
          _vm.pointer = null
        }
      }
    }, [_c('div', {
      staticClass: "w-100 text-left p-3",
      staticStyle: {
        "line-height": "150%"
      }
    }, [_vm._v("\n              " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(_vm.$t('generated_time')) + "：" + _vm._s(item.createTime) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center justify-content-end",
      staticStyle: {
        "width": "430px"
      }
    }, [_c('transition', {
      attrs: {
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "d-none"
      }
    }, [(_vm.pointer !== item.id) ? _c('span', {
      staticClass: "pr-3"
    }, [_vm._v("共 " + _vm._s(item.examPaperCount) + " 份考卷")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "d-none"
      }
    }, [(_vm.pointer === item.id) ? _c('div', {
      staticClass: "w-100 text-right"
    }, [_c('icon-button', {
      attrs: {
        "name": "share",
        "alt": "指派"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push('/exam-mgr/assign/' + item.id)
        }
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "name": "delete",
        "alt": "刪除"
      },
      nativeOn: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    })], 1) : _vm._e()])], 1)])
  }), 0), _vm._v(" "), _c('pagination', {
    staticClass: "mt-5",
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 d-flex"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block w-50 mx-auto",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.push('/exam-mgr/add/exam')
      }
    }
  }, [_vm._v("點我開始建立考試作業清單")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b01a044!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingExam.vue
// module id = 706
// module chunks = 1